export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '直推下级激活奖励记录';